<template>
    <div class="col-xs-10 col-xs-offset-1 col-sm-4 col-sm-offset-4 col-lg-3 col-sm-offset-4 ">
        <div class="content-group">
            <div class="panel-body bg-blue border-radius-top text-center" style="background-image: url(/assets/img/bg.png); background-size: contain;">
                <div class="content-group-sm">
                    <h5 class="text-semibold no-margin-bottom">
                        Andrei Hirvi
                    </h5>
                </div>

                <a href="#" class="display-inline-block content-group-sm">
                    <img src="/assets/img/me.jpg" class="img-circle img-responsive" alt="" style="width: 120px; height: 120px;">
                </a>

                <div class="content-group-sm">
                    <span class="display-block">Senior Software Engineer</span>
                    <span v-if="blockOfLinks" class="display-block">Full-stack developer</span>
                    <span v-else class="display-block">Entrepreneur</span>
                    <span class="display-block">JS Enthusiast</span>
                </div>
            </div>

            <div class="panel panel-body no-border-top no-border-radius-top">
                <div class="form-group mt-5">
                    <label class="text-semibold">Full name:</label>
                    <span class="pull-right-sm">Andrei Hirvi</span>
                </div>

                <div class="form-group">
                    <label class="text-semibold">Phone number:</label>
                    <span class="pull-right-sm">+372 56607807</span>
                </div>

                <div class="form-group">
                    <label class="text-semibold">Email:</label>
                    <span class="pull-right-sm"><a href="#">andrei.hirvi@gmail.com</a></span>
                </div>

                <div class="form-group">
                    <label class="text-semibold">Profile web app:</label>
                    <span class="pull-right-sm"><a href="http://andreihirvi.com" target="_blank">www.andreihirvi.com</a></span>
                </div>

                <div class="form-group">
                    <label class="text-semibold">LinkedIN:</label>
                    <span class="pull-right-sm"><a href="https://www.linkedin.com/profile/view?id=143828758" target="_blank">My profile</a></span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    export default {
        data () {
            return {
                blockOfLinks: window.location.host === 'andrew.ooo'
            }
        }
    }
</script>


// WEBPACK FOOTER //
// About.vue?0a6beaae